module.exports = __webpack_public_path__ + "static/assets/e3a21b920ed4b4c2d9830ec68132c011.svg";